<!-- Button to open the menu -->
<button mat-flat-button class="button-primary" [matMenuTriggerFor]="filterMenu" #menuTrigger>
  <mat-icon class="material-icons-outlined">filter_alt</mat-icon>
  <span class="px-2 font-bold">{{ buttonLabel }} <span *ngIf="filterCounter">({{ filterCounter }})</span></span>
</button>

<!-- Menu body -->
<mat-menu #filterMenu="matMenu" class="filter-popup-box !p-4">
  <ng-template matMenuContent>
    <div class="header flex justify-between mb-1">
      <ng-content select="sp-filter-menu-header"></ng-content>
      <mat-icon #close class="cursor-pointer ml-3" (click)="closed.emit()">close</mat-icon>
    </div>

    <!-- Content -->
    <div class="filters-options" (click)="$event.stopPropagation()">
      <ng-content></ng-content>
    </div>

    <!-- Footer -->
    <div class="footer text-right mt-2">
      <button mat-flat-button class="button-primary mr-2" (click)="clear.emit()">
        <mat-icon>close</mat-icon>
        <span class="font-bold">Reset all</span>
      </button>
      <button mat-flat-button class="button-primary" (click)="apply.emit()">
        <mat-icon>check</mat-icon>
        <span class="font-bold">Apply</span>
      </button>
    </div>
  </ng-template>
</mat-menu>
